<script setup lang="ts">
import ConfirmationModal from "@/components/DailyReportUpdateModalParts/IgnoreLongTimelongContinuousWarningConfirmationModal.vue";
import UpdateModal from "@/components/DailyReportUpdateModalParts/IgnoreLongTimelongContinuousWarningUpdateModal.vue";
import { Ref, ref, computed, watch } from "vue"

const emits = defineEmits(['update:modelValue'])

const props = defineProps<{
  modelValue: boolean,
  deliveryPlanId: string,
  createAuthority: boolean
  showFlash: (message: string, show: boolean, type: string, fadeout: boolean) => void
}>()

const modelValue = computed(() => {
  return props.modelValue;
})

watch(() => props.modelValue,
() => {
  confirmModalState.value = props.modelValue;
})

const confirmModalState:Ref<boolean> = ref(modelValue.value)
const updateModalState:Ref<boolean> = ref(false)

function confirm() {
  confirmModalState.value = false
  updateModalState.value = true
}

function closeModal() {
  emits('update:modelValue', false)
  confirmModalState.value = false
  updateModalState.value = false
}

</script>
<template>
  <ConfirmationModal
    v-model="confirmModalState"
    @confirm="confirm"
    @cancel="closeModal"
  />
  <UpdateModal
    v-if="updateModalState"
    v-model="updateModalState"
    @confirm="confirm"
    @cancel="closeModal"
    :deliveryPlanId="props.deliveryPlanId"
    :createAuthority="props.createAuthority"
    :showFlash="props.showFlash"
  />
</template>
